module.exports = __webpack_public_path__ + "img/carpool_coupon_package_navbar_bg.8ab76525.png";